export default __webpack_public_path__ + "static/media/33.d53fb838.png";